"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgFavourite = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.262 3A5.691 5.691 0 0 0 12.2 4.714l-.2.203-.198-.203a5.675 5.675 0 0 0-8.127 0c-2.232 2.274-2.232 5.954 0 8.229l7.612 7.757a1 1 0 0 0 1.428 0l7.612-7.757A5.873 5.873 0 0 0 22 8.828a5.874 5.874 0 0 0-1.674-4.114A5.691 5.691 0 0 0 16.262 3Zm-11.16 8.542a3.894 3.894 0 0 1 0-5.427 3.675 3.675 0 0 1 5.271 0l.913.93a1 1 0 0 0 1.428 0l.912-.93A3.692 3.692 0 0 1 16.262 5c.988 0 1.935.4 2.636 1.115A3.874 3.874 0 0 1 20 8.828c0 1.02-.397 1.996-1.102 2.714l-.913.93-5.985 6.1-6.899-7.03Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgFavourite);
//# sourceMappingURL=SvgFavourite.js.map